/* eslint-disable no-var */
import { Component, ElementRef, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { LanguageService } from '../../../services/language.service';
import { Visitor } from '../../models/visitor.model';
import { NotifierService } from 'angular-notifier';
import { VisitorChild } from '../../models/visitorChild';
import { ModalController } from '@ionic/angular';
import Keyboard from 'simple-keyboard';
import { IonSelect } from '@ionic/angular';

@Component({
  selector: 'app-register-page',
  templateUrl: './register.page.html',
  styleUrls: ['./register.page.scss'],
})
export class RegisterPage {
 keyboard: Keyboard;
  inputName = "fullName";
  inputs = {
    fullName: "",
    ['fullNameChild1']:"",
    phone:"",
    phonePrefix: "+381",
    email: "",
    day: "",
    month: "",
    year: ""

  };
  addedChild: VisitorChild;
  language$ = this.languageService.language$;
  language: string;
  dateToday = new Date();
  errMsg = '';
  areTermsRead: boolean = false;
  visitor: Visitor = new Visitor();
  isLoading = false;
  visitors: Array<VisitorChild> = [];
  visitorsRegisterForm: Array<VisitorChild> = [];
  childrenForm: Array<VisitorChild> = [];
  isShow = false;
  isChildFormVisible = false;
  childEdit: VisitorChild;
  routerSubscription;
  children: { fullName: string }[] = [{ fullName: '' }];
  childDate: { day: string, month: string, year: string }[] = [{ day: '', month:'', year: '' }];
  days: string[] = Array.from({ length: 31 }, (_, i) => (i + 1).toString());
  months = [
    { name: '1', value: "1" },
    { name: '2', value: "2" },
    { name: '3', value: "3" },
    { name: '4', value: "4" },
    { name: '5', value: "5" },
    { name: '6', value: "6" },
    { name: '7', value: "7" },
    { name: '8', value: "8" },
    { name: '9', value: "9" },
    { name: '10', value: "10" },
    { name: '11', value: "11" },
    { name: '12', value: "12" },
  ];
   phonePrefixes = [
{ code: '+381', flag: 'rs' }, // Srbija  
{ code: '+387', flag: 'ba' }, // Bosna i Hercegovina
{ code: '+389', flag: 'mk' }, // Severna Makedonija  
{ code: '+385', flag: 'hr' }, // Hrvatska  
{ code: '+382', flag: 'me' }, // Crna Gora
{ code: '+7',   flag: 'ru' }, // Rusija  
{ code: '+380', flag: 'ua' }, // Ukrajina  
{ code: '+49',  flag: 'de' }, // Nemačka 
{ code: '+355', flag: 'al' }, // Albanija  
{ code: '+376', flag: 'ad' }, // Andora  
{ code: '+43',  flag: 'at' }, // Austrija  
{ code: '+374', flag: 'am' }, // Jermenija  
{ code: '+32',  flag: 'be' }, // Belgija   
{ code: '+359', flag: 'bg' }, // Bugarska  
{ code: '+357', flag: 'cy' }, // Kipar  
{ code: '+420', flag: 'cz' }, // Češka  
{ code: '+45',  flag: 'dk' }, // Danska  
{ code: '+372', flag: 'ee' }, // Estonija  
{ code: '+358', flag: 'fi' }, // Finska  
{ code: '+33',  flag: 'fr' }, // Francuska  
{ code: '+995', flag: 'ge' }, // Gruzija  
{ code: '+30',  flag: 'gr' }, // Grčka  
{ code: '+36',  flag: 'hu' }, // Mađarska  
{ code: '+354', flag: 'is' }, // Island  
{ code: '+353', flag: 'ie' }, // Irska  
{ code: '+39',  flag: 'it' }, // Italija  
{ code: '+371', flag: 'lv' }, // Letonija  
{ code: '+423', flag: 'li' }, // Lihtenštajn  
{ code: '+370', flag: 'lt' }, // Litvanija  
{ code: '+352', flag: 'lu' }, // Luksemburg  
{ code: '+356', flag: 'mt' }, // Malta  
{ code: '+373', flag: 'md' }, // Moldavija  
{ code: '+377', flag: 'mc' }, // Monako  
{ code: '+31',  flag: 'nl' }, // Holandija  
{ code: '+47',  flag: 'no' }, // Norveška  
{ code: '+48',  flag: 'pl' }, // Poljska  
{ code: '+351', flag: 'pt' }, // Portugal  
{ code: '+40',  flag: 'ro' }, // Rumunija  
{ code: '+421', flag: 'sk' }, // Slovačka  
{ code: '+386', flag: 'si' }, // Slovenija  
{ code: '+34',  flag: 'es' }, // Španija  
{ code: '+46',  flag: 'se' }, // Švedska  
{ code: '+41',  flag: 'ch' }, // Švajcarska  
{ code: '+44',  flag: 'gb' }, // Velika Britanija  
{ code: '+90',  flag: 'tr' },  // Turska
{ code: '+1',   flag: 'us' }, // Sjedinjene Američke Države
{ code: '+1',   flag: 'ca' }, // Kanada
{ code: '+61',  flag: 'au' }  // Australija
];
selectedPrefix = this.phonePrefixes[0]; // Default: +381 (Srbija)
dropdownOpen = false;
  years: string[] = [];
  @ViewChildren('daySelect') daySelects!: QueryList<IonSelect>;
  @ViewChildren('monthSelect') monthSelects!: QueryList<IonSelect>;
  @ViewChildren('yearSelect') yearSelects!: QueryList<IonSelect>;


  constructor(
    private router: Router,
    private languageService: LanguageService,
    private notifierService: NotifierService,
    private modalController: ModalController,
  )
  {
    this.childEdit = new VisitorChild();
    this.routerSubscription = this.router.events.subscribe((route: any) => {
      // clear data once we redirect to home
      if(route.url === '/registration/home') {
        this.visitor = new Visitor();
        this.visitors = [];
        this. visitorsRegisterForm = [];
        this.children = [];
        this.childDate = [];
        this.inputs.fullName ="";
        this.inputs['fullNameChild']="";
        this.inputs.phone = "";
        this.inputs.email = "";
        window.location.reload();
      }
    })
    const currentYear = new Date().getFullYear();
    this.years = Array.from({ length: 100 }, (_, i) => (currentYear - i).toString());
  }
  pagePath: string;
  signaturePad: any;
  isSignatured: boolean = false;

  ngOnInit() {
    this.visitor = new Visitor();
    this.language$.subscribe((lng) => (this.language = lng.toUpperCase()));
    this.pagePath = this.router.url;
    this.inputs[this.inputName] = "";
  }
  toggleDisplay() {
    this.visitors.push({
      fullName: '',
    });
}
  ngOnDestroy() {
    this.routerSubscription.unsubscribe();
  }

  ngAfterViewInit() {
    this.keyboard = new Keyboard({
      inputName: this.inputName,
     
      onChange: (input) => this.onChange(input),
      onKeyPress: (button) => this.onKeyPress(button),
      preventMouseDownDefault: true // If you want to keep focus on input
     
    });
    /**
     * Since we have default values for our inputs,
     * we must sync them with simple-keyboard
     */
    
    this.keyboard.replaceInput(this.inputs);

    setTimeout(() => {
      console.log('IonSelect instances:', this.daySelects.toArray());
    }, 500);
  }

  onInputFocus = (event: any) => {
    this.inputName = event.target.id;
    

    console.log("Focused input", this.inputName);

    this.keyboard.setOptions({
      inputName: event.target.id
    });
  };

  setInputCaretPosition = (elem: any, pos: number) => {
    if (elem.setSelectionRange) {
      elem.focus();
      elem.setSelectionRange(pos, pos);
    }
  };

  onInputChange = (event: any) => {
    this.keyboard.setInput(event.target.value, event.target.id);
   
  };

  onChange = (input: string) => {
    if (this.inputName === 'email') {
      this.inputs[this.inputName] = input.toLowerCase();
    } else {
      this.inputs[this.inputName] = input.toUpperCase();
    }
    console.log("Input changed", input);
    
    /**
     * Synchronizing input caret position
     * This part is optional and only relevant if using the option "preventMouseDownDefault: true"
     */
    let caretPosition = this.keyboard.caretPosition;

    if (caretPosition !== null)
      this.setInputCaretPosition(
        document.querySelector(`#${this.inputName}`),
        caretPosition
      );

    console.log("caretPosition", caretPosition);
   
  };
 
  onKeyPress = (button: string) => {
    console.log("Button pressed", button);
   
    /**
     * If you want to handle the shift and caps lock buttons
     */
    if (button === "{shift}") this.handleShift();
  };

  handleShift = () => {
    let currentLayout = this.keyboard.options.layoutName;
    let shiftToggle = currentLayout === "default" ? "shift" : "default";

    this.keyboard.setOptions({
      layoutName: shiftToggle
    });
  };

  toggleLanguage() {
    this.language = this.language === 'EN' ? 'SR' : 'EN';
    this.languageService.setLanguage(this.language.toLowerCase());
  }

  clear() {
    this.signaturePad.clear();
    this.isSignatured = false;
   
  }

  setIsSignatured() {
    this.isSignatured = true;
  }

  isCanvasBlank(): boolean {
    if (this.signaturePad) {
      return this.signaturePad.isEmpty() ? true : false;
    }
  }

  showErrorAndRedirect(error) {
    this.notifierService.show({
      message: '' + JSON.stringify(error.error.title),
      type: 'warning',
    });
    this.isLoading = false;
  }

  showSuccessAndRedirect() {
    this.notifierService.show({
      message: 'Poseta uspešno registrovana!',
      type: 'success',
    });
    this.visitor = new Visitor();
    this.visitors = [];
    this.areTermsRead = false;
    this.signaturePad.clear();
    this.router.navigateByUrl('/registration/home');
  }

  areFirstFieldsPopulated(): boolean {
    const hasParentName = !!this.inputs.fullName?.trim(); 
    const isPhoneValid = !!this.inputs.phone && !isNaN(Number(this.inputs.phone)) && this.inputs.phone.length >= 6;
    const hasPrefix = !!this.inputs.phonePrefix;

    return hasParentName && isPhoneValid && hasPrefix;
}

goToOtherPage() {
  this.fillVisitorData();

  const newChildren = [];
  for (let i = 0; i < this.children.length; i++) {
    const inputKey = 'fullNameChild' + (i + 1);
    const childFullName = this.inputs[inputKey];

    if (childFullName) {
      
      if (!this.childDate[i].month) {
        this.childDate[i].month = '01';
      }
      if (!this.childDate[i].year) {
        this.childDate[i].year = '1800';
      }
      
      const birthDate = `${this.childDate[i].year}-${this.childDate[i].month.padStart(2, '0')}-01`;

      newChildren.push({
        fullName: childFullName,
        birthDate: birthDate,
      });
    }
  }

  this.visitorsRegisterForm = newChildren;

  let visitorJson = JSON.stringify(this.visitor);
  let visitorsFormJson = JSON.stringify(this.visitorsRegisterForm);

  this.router.navigate(['/registration/consent', { visitor: visitorJson, visitorsFormJson }]);
}

  
  addChildIfNotExists(name, inputName) {
    if (name) {
      const existingChild = this.visitorsRegisterForm.find(child => child.fullName === name);
      
      if (!existingChild) {
        this.visitorsRegisterForm.push({ fullName: name });
      }
    }
  }
  
hasVisitor(name) {
  return this.visitorsRegisterForm.some(visitor => visitor.fullName === name);
}

    resetForm(i)  {
      this.visitors.splice(i,1);
    }

    fillVisitorData() {
      this.visitor.fullName = this.inputs.fullName;
      this.visitor.phone = this.inputs.phonePrefix + this.inputs.phone;
      this.visitor.email = this.inputs.email;
    }

    addInputField() {
      if (this.children.length < 100) {
        this.children.push({ fullName: '' });
        this.childDate.push({ day: '', month: '', year: '' });
      }
    }

    removeInputField(index: number) {
      if (index >= 0 && index < this.children.length) {
        this.children.splice(index, 1);
        this.childDate.splice(index, 1);
      }
    }

    gotoNextField(nextElement){
        nextElement.setFocus();
    }

    addChild() {
      this.addedChild = new VisitorChild();
      this.addedChild.fullName = this.inputs.fullName;
    }

    shouldEnableField(index: number): boolean {
      return !this.inputs['fullNameChild' + (index + 1)] || this.inputs['fullNameChild' + (index + 1)].trim() === '';
    }
  
    areNamesValid(): boolean {
      for (let i = 0; i < this.children.length; i++) {
        const inputName = this.inputs['fullNameChild' + (i + 1)];
        if (inputName && !/^[a-zA-Z]+(?:\s+[a-zA-Z]+)+$/.test(inputName)) {
          return false;
        }
      }
      return true;
    }  
    
    isNameInvalid(name: string): boolean {
      if (!name || !name.trim()) return true;
      const words = name.trim().split(/\s+/); 
      return words.length < 2;
    }
    

    openSelect(type: string, index: number, event: any) {
      let select: IonSelect | undefined;
    
      if (type === 'month') {
        select = this.monthSelects.toArray()[index];
      } else if (type === 'year') {
        select = this.yearSelects.toArray()[index];
      }
    
      if (select) {
        select.open(event);
      }
    }

    dismissPopover() {
      setTimeout(() => {
        const popover = document.querySelector('ion-popover');
        if (popover) {
          (popover as any).dismiss();
        }
      }, 50);
    }
  
    getMonthName(monthValue: string): string {
      const month = this.months.find(m => m.value === monthValue);
      return month ? month.name : "";
    }

      toggleDropdown() {
  this.dropdownOpen = !this.dropdownOpen;
}

selectPrefix(prefix: { code: string; flag: string }) {
  this.selectedPrefix = prefix;
  this.inputs.phonePrefix = prefix.code;
  this.dropdownOpen = false;
}
}
    

    


